import React, { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";

const baseURL = import.meta.env.VITE_API_URL || "/";

type CustomListFilters = {
    keyword?: string;
    location?: string;
    lat?: number;
    lng?: number;
    categories?: string[];
    priceMin?: number;
    priceMax?: number;
    excludedProviders?: string[];
};

type PublicCustomList = {
    partnerSlug: string;
    name: string;
    slug: string;
    filters: CustomListFilters;
};

const buildSearchUrl = (list: PublicCustomList): string => {
    const params = new URLSearchParams();
    params.set("utm_source", list.partnerSlug);
    params.set("utm_medium", "referral");
    params.set("utm_campaign", list.slug);
    params.set("custom_list", list.slug);
    if (list.filters.keyword) params.set("q", list.filters.keyword);
    if (list.filters.lat != null && list.filters.lng != null) {
        params.set("lat", String(list.filters.lat));
        params.set("lng", String(list.filters.lng));
    } else if (list.filters.location) {
        params.set("location", list.filters.location);
    }
    if (list.filters.categories?.length) params.set("categories", list.filters.categories.join(","));
    if (list.filters.priceMin != null) params.set("priceMin", String(list.filters.priceMin));
    if (list.filters.priceMax != null) params.set("priceMax", String(list.filters.priceMax));
    return `/search?${params.toString()}`;
};

export const CustomListRedirect = () => {
    const { partnerSlug, listSlug } = useParams<{ partnerSlug: string; listSlug: string }>();
    const [target, setTarget] = useState<string | null>(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        if (!partnerSlug || !listSlug) {
            setNotFound(true);
            return;
        }
        fetch(`${baseURL}/api/public/custom-lists/${partnerSlug}/${listSlug}`)
            .then((res) => {
                if (res.status === 404) {
                    setNotFound(true);
                    return null;
                }
                if (!res.ok) throw new Error("Failed to load custom list.");
                return res.json() as Promise<PublicCustomList>;
            })
            .then((list) => {
                if (list) setTarget(buildSearchUrl(list));
            })
            .catch(() => setNotFound(true));
    }, [partnerSlug, listSlug]);

    if (notFound) return <Redirect to="/search" />;
    if (target) return <Redirect to={target} />;
    return <div style={{ padding: 40, textAlign: "center", color: "#64748b" }}>Loading…</div>;
};

export default CustomListRedirect;
